<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      :selectShow="false"
      addShowPower="/offlineQRcode/add"
    >
    </common-top-form>
    <common-table
      :data="tableData"
      ref="commonTable"
      @handleChange="getPage"
      :isShow="false"
    >
      <el-table-column
        prop="simpleTatId"
        label="品牌简称"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="名称"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        :formatter="formatterTableTrantype"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="image" label="收款码" min-width="100">
        <template slot-scope="scope">
          <div
            class="iconUrl"
            :style="
              'background:url(' + scope.row.qrUrl + ') center/cover no-repeat'
            "
          ></div>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="注意事项"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="操作"
        min-width="160"
        v-if="
          hasPerm('/offlineQRcode/update') ||
          hasPerm('/offlineQRcode/del') ||
          hasPerm('/offlineQRcode/status')
        "
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="hasPerm('/offlineQRcode/update')"
            @click="openAddDialog(scope.row)"
            >修改</el-button
          >
          <el-button
            type="text"
            v-if="hasPerm('/offlineQRcode/del')"
            @click="handleDelete(scope.row)"
            >删除</el-button
          >
          <el-button
            type="text"
            @click="Disabled(scope.row)"
            v-if="hasPerm('/offlineQRcode/status')"
            class="button-color"
            >{{ scope.row.status == 1 ? "停用" : "启用" }}</el-button
          >
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @success="dialogSuccess"
      @close="dialogClose"
      class="note"
    >
      <select-organs
        v-model="dialogModel.simpleTatId"
        :selectValue="dialogModel.simpleTatId"
        :needAll="false"
        selectWidth="100%"
        selectProp="simpleTatId"
      ></select-organs>
      <el-form-item label="名称" prop="name">
        <el-input
          type="text"
          v-model="dialogModel.name"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="收款码" prop="qrUrl">
        <el-upload
          class="avatar-uploader"
          :action="uploadUrl + '8883/picture/upload'"
          :data="commonParams"
          name="picture"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img
            v-if="dialogModel.qrUrl"
            :src="dialogModel.qrUrl"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="注意事项" prop="remark">
        <el-input
          type="textarea"
          placeholder="请输入"
          v-model="dialogModel.remark"
          maxlength="300"
          rows="5"
          show-word-limit
        >
        </el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import Server from "common/conf/Server";
import privateKey from "service/constant/privateKey";
import SelectOrgans from "components/business/SelectOrgans";

import MallService from "service/MallService";
import TimeRange from "service/constant/TimeRange";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "offlineQRcode",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    SelectOrgans,
  },
  data() {
    return {
      uploadUrl: Server[process.env.NODE_ENV],
      formModel: {},
      tableData: [],
      submitService: MallService.offlineQRcodeList,
      page: {},
      isPage: false,
      itemId: "",
      dialogModel: {
        simpleTatId: "",
        name: "",
        qrUrl: "",
        remark: "",
      },
      dialogRules: {
        simpleTatId: [
          {
            required: true,
            message: "请选择",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入收款码",
          },
        ],
      },
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    commonParams() {
      const params = {
        serverType: this.serverType,
        tatId: this.tatId,
        reqTime: new Date().format("yyyy-MM-dd HH:mm:ss"),
      };
      params.sign = encrypt(
        urlEncode(objKeySort(params)) + "&priKey=" + privateKey.priKey
      );
      return params;
    },
    submitData() {
      const params = {
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogData() {},
    dialogService() {
      return this.itemId
        ? MallService.offlineQRcodeEdit
        : MallService.offlineQRcodeInsert;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  methods: {
    load() {
      this.formModel = {};

      this.page = this.$refs.commonTable.page;

      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    formatterTableTrantype: function (row, column) {
      switch (row.status) {
        case "0":
          return "停用";
          break;
        case "1":
          return "启用";
          break;
        default:
          return "--";
      }
    },
    handleDelete(item) {
      this.showConfirm("确定删除该类别？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        MallService.offlineQRcodeDel,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    doDisabled(item) {
      this.doLoad(
        MallService.offlineQRcodeStatus,
        {
          id: item.id,
          status: item.status == "1" ? "0" : "1",
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    Disabled(item) {
      this.showConfirm(`确定${item.status == 0 ? "启用" : "停用"}？`)
        .then(() => {
          this.doDisabled(item);
        })
        .catch(() => {});
    },
    openAddDialog(item) {
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.dialogModel = JSON.parse(JSON.stringify(item));
      }
      this.$refs.formDialog.open();
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    dialogClose() {
      this.dialogModel = {
        simpleTatId: "",
        name: "",
        qrUrl: "",
        remark: "",
      };
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    handleAvatarSuccess(res, file) {
      this.doCheck(res, (res) => {
        this.dialogModel.qrUrl = res.contents;
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 / 1024 < 3;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 3MB!");
      }
      return isLt2M;
    },
  },
};
</script>

<style scoped>
.currentTatName {
  margin-bottom: 30px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
  border: 1px solid #d9d9d9;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/OfflineQRCode.vue